// extracted by mini-css-extract-plugin
module.exports = {"StoryboardSwitcher":"storyboard_StoryboardSwitcher__-CzHu","storyboards":"storyboard_storyboards__3SyaD","storyboard":"storyboard_storyboard__1aCoP"};